import { useEffect, useRef, useState } from "react";
import api from "../api";

const FIELD_DEFS = [
  ["name", "Nome e cognome", "Silvia Casali"],
  ["role", "Ruolo", "Dottore Commercialista"],
  ["company", "Studio / società", "SC Dottori Commercialisti S.r.l. STP"],
  ["phone", "Telefono", "0544 …"],
  ["website", "Sito web", "www.casalisilvia.com"],
  ["address", "Indirizzo", "Via Ponte Marino 43 · 48121 Ravenna (RA)"],
];

export default function SignatureEditor() {
  const [senders, setSenders] = useState([]);
  const [mailboxId, setMailboxId] = useState("");
  const [fields, setFields] = useState({});
  const [hasImage, setHasImage] = useState(false);
  const [preview, setPreview] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState("");
  const fileRef = useRef(null);

  useEffect(() => {
    api.get("/email-templates/senders").then((r) => setSenders(r.data)).catch(() => {});
  }, []);

  const load = (mid) => {
    api.get(`/emails/signature${mid ? `?mailbox_id=${mid}` : ""}`).then((r) => {
      setFields(r.data.fields || (r.data.signature && !r.data.is_html ? { free: r.data.signature } : {}));
      setHasImage(r.data.has_image);
      setPreview(r.data.is_html ? r.data.signature : "");
      setMsg("");
    }).catch(() => {});
  };
  useEffect(() => { load(mailboxId); }, [mailboxId]); // eslint-disable-line

  const save = async () => {
    setBusy("save");
    try {
      const r = await api.put("/emails/signature", { mailbox_id: mailboxId || null, fields });
      setPreview(r.data.signature);
      setMsg("✅ Firma salvata: verrà inserita in fondo ai messaggi di questa casella.");
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    setBusy("");
  };

  const uploadImage = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy("img");
    try {
      const fd = new FormData();
      fd.append("file", f);
      if (mailboxId) fd.append("mailbox_id", mailboxId);
      const r = await api.post("/emails/signature/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setHasImage(true); setPreview(r.data.signature);
      setMsg("✅ Foto caricata: apparirà nel tondino della firma.");
    } catch (er) { setMsg("Errore: " + (er.response?.data?.detail || er.message)); }
    setBusy("");
    if (fileRef.current) fileRef.current.value = "";
  };

  const removeImage = async () => {
    setBusy("img");
    try {
      const r = await api.delete(`/emails/signature/image${mailboxId ? `?mailbox_id=${mailboxId}` : ""}`);
      setHasImage(false); setPreview(r.data.signature);
    } catch (e) { setMsg("Errore: " + (e.response?.data?.detail || e.message)); }
    setBusy("");
  };

  const upd = (k) => (e) => setFields({ ...fields, [k]: e.target.value });

  return (
    <div className="panel" data-testid="signature-panel">
      <h3>✍️ Firma email</h3>
      <p className="muted">Firma professionale con foto nel tondino, diversa per ogni casella. Viene inserita in fondo a nuove email, risposte e inoltri.</p>

      <div className="field" style={{ maxWidth: 340 }}>
        <label>Casella</label>
        <select value={mailboxId} onChange={(e) => setMailboxId(e.target.value)} data-testid="signature-mailbox">
          <option value="">Tutte le caselle (firma generale)</option>
          {senders.map((s) => <option key={s.id} value={s.id}>{s.address}</option>)}
        </select>
      </div>

      <div className="grid-2">
        {FIELD_DEFS.map(([k, label, ph]) => (
          <div className="field" key={k}>
            <label>{label}</label>
            <input value={fields[k] || ""} onChange={upd(k)} placeholder={ph} data-testid={`signature-${k}`} />
          </div>
        ))}
      </div>
      <div className="field">
        <label>Testo libero sopra la firma (es. "Cordiali saluti,")</label>
        <textarea rows={2} value={fields.free || ""} onChange={upd("free")} placeholder={"Cordiali saluti,"} data-testid="signature-free" />
      </div>

      <div className="toolbar" style={{ gap: 8, flexWrap: "wrap" }}>
        <input ref={fileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={uploadImage} data-testid="signature-image-input" />
        <button className="btn" disabled={busy === "img"} onClick={() => fileRef.current?.click()} data-testid="signature-image-btn">
          {busy === "img" ? "…" : hasImage ? "🖼 Cambia foto del tondino" : "🖼 Carica foto per il tondino"}
        </button>
        {hasImage && <button className="btn" onClick={removeImage} data-testid="signature-image-remove">✕ Rimuovi foto</button>}
        <div className="spacer" />
        <button className="btn primary" onClick={save} disabled={busy === "save"} data-testid="signature-save">{busy === "save" ? "…" : "Salva firma"}</button>
      </div>

      {preview && (
        <div className="field" style={{ marginTop: 10 }}>
          <label>👁 Anteprima</label>
          <div style={{ background: "#fff", borderRadius: 10, padding: 14 }} data-testid="signature-preview"
            dangerouslySetInnerHTML={{ __html: preview }} />
        </div>
      )}

      {msg && <p className="muted" style={{ marginTop: 8 }} data-testid="signature-msg">{msg}</p>}
    </div>
  );
}
